import { render, staticRenderFns } from "./ModalAjudaChatbot.vue?vue&type=template&id=07976568&scoped=true&"
import script from "./ModalAjudaChatbot.vue?vue&type=script&lang=js&"
export * from "./ModalAjudaChatbot.vue?vue&type=script&lang=js&"
import style0 from "./ModalAjudaChatbot.vue?vue&type=style&index=0&id=07976568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07976568",
  null
  
)

export default component.exports